import { Pipe, PipeTransform } from '@angular/core';

/**
 * Подменяет символы
 * Input: '8 (800) 700-10-10' | sdReplace: '[^0-9]+':''
 * Output: '88007001010'
 */
@Pipe({
  name: 'sdReplace',
  standalone: true,
})
export class ReplacePipe implements PipeTransform {
  transform(value: string, regex: string, replacement: string): string {
    if (typeof regex === 'undefined' || typeof replacement === 'undefined') {
      return value;
    }

    return value.replace(new RegExp(regex, 'g'), replacement);
  }
}
